import Vue from 'vue'
import App from '@/pages/home/App.vue'
import router from '@/pages/home/router'
import store from '@/pages/home/store'
import vuetify from '@/pages/home/plugins/vuetify';
import vueMoment from 'vue-moment';
import moment from 'moment-timezone';

// 방문예약 플러그인
import commonWindow from '@/plugins/commonWindow/commonWindow';
import axiosHelper from '@/plugins/axiosHelper';
import getPluginInstance from "@/plugins/codeManager";
import registerGlobalFilters from "@/assets/js/filters";

// moment 타임존 추가
require('moment/locale/ko');

Vue.config.productionTip = false;

// 플러그인 등록
getPluginInstance().then(codePlugin => {
    Vue.use(vueMoment, {moment});
    Vue.use(commonWindow);
    Vue.use(axiosHelper, {includeTokenHeader: false, axiosConfig: null});
    Vue.use(codePlugin);
    registerGlobalFilters();

    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
    }).$mount('#app')
})
